import * as React from 'react'
import { useTranslation } from 'react-i18next'

export type RemainingCharactersProps = {
  maxLength: number | undefined
  valueLength: number | undefined
  style?: React.CSSProperties
}

const RemainingCharacters: React.FunctionComponent<RemainingCharactersProps> = (props: RemainingCharactersProps) => {
  const { t } = useTranslation()
  const remainingCharacters =
    props.maxLength && props.valueLength ? props.maxLength - props.valueLength : String(props.maxLength)
  return (
    <span className='float-right font-body-small-regular font-lightgray' style={props.style}>
      {t('message.maxLengthLabel', `${remainingCharacters} characters remaining`, {
        value: remainingCharacters,
      })}
    </span>
  )
}

export default RemainingCharacters
